module.exports = __webpack_public_path__ + "static/media/PNG.77bb95a7.png";